import { render, staticRenderFns } from "./LettersSoundsSyllablesForm.vue?vue&type=template&id=54624af9&scoped=true&lang=pug&"
import script from "./LettersSoundsSyllablesForm.vue?vue&type=script&lang=js&"
export * from "./LettersSoundsSyllablesForm.vue?vue&type=script&lang=js&"
import style0 from "./LettersSoundsSyllablesForm.vue?vue&type=style&index=0&id=54624af9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54624af9",
  null
  
)

export default component.exports